import React from "react";
import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import {
  faSort,
  faSortUp,
  faSortDown,
} from "@fortawesome/free-solid-svg-icons";

export type SortOrder = "asc" | "desc" | "none";

interface SortOrderIconProps extends Omit<FontAwesomeIconProps, "icon"> {
  order: SortOrder;
}

export const SortOrderIcon: React.FC<SortOrderIconProps> = ({
  order,
  className = "text-secondary",
  ...otherProps
}) => {
  const icon =
    order === "asc" ? faSortUp : order === "desc" ? faSortDown : faSort;

  return (
    <FontAwesomeIcon
      className={className}
      size="xs"
      icon={icon}
      {...otherProps}
      aria-label="Toggle sort order"
    />
  );
};
